import { Language } from "./language";

export class ICTranslation {
  DeleteDate: string;
  Id: number;
  IdGuid: string;
  InsertDate: string;
  Key: string;
  Language: Language;
  LastEditDate: string;
  Table: string;
  Type: string;
  Value: string;

  constructor(data?: Partial<ICTranslation>) {
    Object.assign(this, data);
  }
}
